import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { EnabledModules } from '../../../core/types/entities/partner/modules-setup/modules'
import { AccountUserSessionInfo } from '../types/AccountUserSession'

export interface LoggedUser {
    account_user_email: string
    account_user_name: string
    account_user_partner: string
    account_user_role_type: string
    account_user_role_type_alias: string
    account_user_roles: { id: string; type: string; value: string }
    account_user_session_token: string
    hub_partner_id: string
    partner_id: string | number
    sales_team_member_id: string
    self_service_welcome: boolean
}
@Injectable({
    providedIn: 'root',
})
export class ManageLoggedUser {
    private userLogged = new BehaviorSubject(null)
    userLogged$ = this.userLogged.asObservable()

    private userModules$ = new BehaviorSubject<EnabledModules | null>(null)

    isLoggedIn(): boolean {
        const { success, loggedUser } = this.getLoggedAccountUser()
        if (success) this.userLogged.next(loggedUser)
        return success
    }

    get loggedUser() {
        const { loggedUser } = this.getLoggedAccountUser()
        return loggedUser! as AccountUserSessionInfo
    }

    getLoggedAccountUser() {
        const encodedLoggedUser = localStorage.getItem('partnerhub-id-user')
        let loggedUser
        if (encodedLoggedUser) {
            const decodedLoggedUser = decodeURIComponent(escape(atob(encodedLoggedUser)))
            loggedUser = decodedLoggedUser ? JSON.parse(decodedLoggedUser) : JSON.parse(encodedLoggedUser)
        }

        if (!loggedUser) return { success: false }
        else return { success: true, loggedUser }
    }

    setLoggedAccountUser(accountUserToSet: any) {
        localStorage.setItem('partnerhub-id-user', accountUserToSet)
        this.userLogged.next(this.getLoggedAccountUser().loggedUser)
    }

    removeLoggedAccountUser() {
        this.userLogged.next(null)
        this.userModules$.next(null)
        localStorage.removeItem('partnerhub-id-user')
    }

    observeUserModules() {
        return this.userModules$.asObservable()
    }

    setUserModules(modules: EnabledModules) {
        this.userModules$.next(modules)
    }

    getUserModules() {
        return this.userModules$.getValue()
    }
}
